import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import classNames from 'classnames';
import styled from 'styled-components';
import { KOALA, OLAF } from 'HubStyleTokens/colors';
import { JUPITER_LAYER } from 'HubStyleTokens/sizes';
import { SLIDEIN_MODAL_TRANSITION_TIMING } from 'HubStyleTokens/times';
import TwoWayTransition from '../transitions/TwoWayTransition';
import UILayer from '../layer/UILayer';
import memoizeOne from 'react-utils/memoizeOne';
import { SandboxContext } from '../context/SandboxContext';

const getTransitionProps = animateOnMount => ({
  transitionOnMount: animateOnMount
});

const transitionTime = parseInt(SLIDEIN_MODAL_TRANSITION_TIMING, 10);
const StickyFooter = styled(props => {
  const rest = _objectWithoutPropertiesLoose(props, ["sandboxed"]);

  return /*#__PURE__*/_jsx("div", Object.assign({}, rest));
}).withConfig({
  displayName: "UIStickyFooter__StickyFooter",
  componentId: "sc-1ec8itv-0"
})(["background:", ";border-top:1px solid ", ";bottom:0;left:0;position:", ";right:0;z-index:", ";"], OLAF, KOALA, ({
  sandboxed
}) => sandboxed ? 'absolute' : 'fixed', JUPITER_LAYER);
const StickyFooterTransitionWrapper = styled(props => {
  const {
    open,
    transitioning
  } = props,
        rest = _objectWithoutPropertiesLoose(props, ["open", "transitioning"]);

  return /*#__PURE__*/_jsx(TwoWayTransition.PlainWrapper, Object.assign({
    "data-component-name": "UIStickyFooter",
    "data-open-complete": open && !transitioning
  }, rest));
}).withConfig({
  displayName: "UIStickyFooter__StickyFooterTransitionWrapper",
  componentId: "sc-1ec8itv-1"
})(["", "{transition-property:", ";transition-duration:", "ms;transform:", ";}"], StickyFooter, ({
  transitionActive
}) => transitionActive ? 'transform' : 'none', transitionTime, ({
  open
}) => `translateY(${open ? '0' : '100'}%)`);

function StickyFooterTransition(props) {
  return /*#__PURE__*/_jsx(TwoWayTransition, Object.assign({}, props, {
    duration: transitionTime,
    Wrapper: StickyFooterTransitionWrapper
  }));
}

class UIStickyFooter extends PureComponent {
  constructor(props) {
    super(props);
    this._getTransitionProps = memoizeOne(getTransitionProps);
  }

  render() {
    const _this$props = this.props,
          {
      animateOnMount,
      className
    } = _this$props,
          rest = _objectWithoutPropertiesLoose(_this$props, ["animateOnMount", "className"]);

    const {
      sandboxed
    } = this.context;

    const renderedFooter = /*#__PURE__*/_jsx(StickyFooter, Object.assign({}, rest, {
      className: classNames(className, 'private-sticky-footer'),
      sandboxed: sandboxed
    }));

    return sandboxed ? renderedFooter : /*#__PURE__*/_jsx(UILayer, {
      "data-layer-for": "UIStickyFooter",
      Transition: StickyFooterTransition,
      transitionProps: this._getTransitionProps(animateOnMount),
      children: renderedFooter
    });
  }

}

const propTypes = {
  animateOnMount: PropTypes.bool.isRequired,
  children: PropTypes.node
};
UIStickyFooter.propTypes = propTypes;
UIStickyFooter.contextType = SandboxContext;
const defaultProps = {
  animateOnMount: true
};
UIStickyFooter.defaultProps = defaultProps;
UIStickyFooter.displayName = 'UIStickyFooter';
export default UIStickyFooter;